import { useEffect, useContext, useState }  from 'react';
import { useBackOffice, BackOfficeContext } from '../../contexts/BackOfficeContext';
import '../../styles/Table.css';
import api                                  from '../../services/api.js'

function UserGroupsTable (){

    const { groups }           = useContext(BackOfficeContext)
    const { handleSetGroups }  = useBackOffice()

    const [loading, isLoading] = useState(true)

    useEffect(() => {

        async function getGroups(){
            
            const response = await api.get('/userGroups')

            handleSetGroups(response.data.map(item => ({
                value: item.id,
                label: item.name
            })))

            isLoading(true)

        }

        getGroups()
        isLoading(false)

    }, [ handleSetGroups ])

    return(

        <> 
        { loading ? (
            <table className='table-pattern-sistem w-[50%] borda-cinza mt-4'>
                <thead className='bg-neutro'>
                    <tr>
                        <th>id</th>
                        <th>Grupo</th>

                    </tr>
                </thead>
                <tbody>
                    {groups.map((item) => (
                        <tr key={item.value}>
                            <td>{item.value} </td>
                            <td>{item.label} </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        ) : (
        

            <table className="table-pattern-sistem w-[50%] borda-cinza mt-4">

                <thead className="bg-neutro">
                    <tr>
                        <th><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></th>

                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>

                </tbody>
            </table>
        )}
         
        </>
    )

}

export default UserGroupsTable;